import React, { useEffect } from 'react'

function UploadErrorModal({ isOpen, onClose, message }) {
  // Handle escape key
  useEffect(() => {
    if (!isOpen) return
    
    function handleEscape(e) {
      if (e.key === 'Escape') {
        onClose()
      }
    }
    
    document.addEventListener('keydown', handleEscape)
    return () => document.removeEventListener('keydown', handleEscape)
  }, [isOpen, onClose])

  if (!isOpen) {
    return null
  }

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(0, 0, 0, 0.5)',
        backdropFilter: 'blur(4px)',
        zIndex: 10000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px'
      }}
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-labelledby="upload-error-title"
      aria-describedby="upload-error-description"
    >
      <div
        className="card"
        style={{
          maxWidth: '512px',
          width: '100%',
          maxHeight: '90vh',
          overflow: 'auto',
          position: 'relative',
          padding: '24px'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: '20px'
        }}>
          <h2 id="upload-error-title" style={{ 
            margin: 0, 
            fontSize: '18px', 
            fontWeight: '600', 
            color: 'var(--text-primary)', 
            display: 'flex', 
            alignItems: 'center',
            gap: '8px'
          }}>
            <i className="fas fa-exclamation-triangle" aria-hidden="true" style={{ color: 'var(--color-error)' }}></i>
            <span>Upload Failed</span>
          </h2>
          <button
            onClick={onClose}
            className="ghost"
            style={{
              padding: '4px',
              minWidth: 'auto',
              minHeight: 'auto',
              width: '32px',
              height: '32px',
              fontSize: '20px',
              color: 'var(--text-secondary)'
            }}
            aria-label="Close error modal"
          >
            ×
          </button>
        </div>
        <div id="upload-error-description" style={{ marginBottom: '24px' }}>
          <p style={{ marginBottom: '16px', fontSize: '14px', lineHeight: '1.6', color: 'var(--text-primary)' }}>
            {message || 'The upload failed because data couldn\'t be extracted from the image.'}
          </p>
          <div className="card" style={{ 
            padding: '16px', 
            backgroundColor: 'var(--color-error-bg)', 
            borderColor: 'var(--color-error-border)',
            borderWidth: '1px'
          }}>
            <strong style={{ 
              display: 'block', 
              marginBottom: '12px',
              fontSize: '14px',
              fontWeight: '600',
              color: 'var(--color-error)'
            }}>
              <i className="fas fa-lightbulb" aria-hidden="true" style={{ marginRight: '6px' }}></i>
              Tips for better results:
            </strong>
            <ul style={{ margin: 0, paddingLeft: '20px', fontSize: '14px', lineHeight: '1.6', color: 'var(--text-primary)' }}>
              <li>Use a clear, well-lit photo</li>
              <li>Take the photo from a flat angle (not at an angle)</li>
              <li>Ensure the recipe text is clearly visible and in focus</li>
              <li>Avoid glare and shadows on the image</li>
              <li>Make sure the image is not blurry or low resolution</li>
            </ul>
          </div>
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px' }}>
          <button
            onClick={onClose}
            className="secondary"
            style={{
              padding: '8px 16px',
              fontSize: '14px',
              minHeight: '44px'
            }}
            aria-label="Close"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  )
}

export default UploadErrorModal

